import React from "react"
import { BrowserRouter, Routes, Route } from "react-router-dom"
import LandingPage from "./LandingPage"
import SuggestionApp from "./SuggestionApp"
import AdminPage from "./AdminPage"
import ShowForm from "./admin/ShowForm"
import AppPage from "./AppPage"
import SelectAskFor from "./SelectAskFor"
import AudienceDisplay from "./AudienceDisplay"
import SuperSecretPhone from "./SuperSecretPhone"

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/suggestions" element={<SuggestionApp />} />
        <Route path="/app" element={<AppPage />} />
        <Route path="/select_askfor" element={<SelectAskFor />} />
        <Route path="/audience_display" element={<AudienceDisplay />} />
        <Route path="/super_secret/phone" element={<SuperSecretPhone />} />
        <Route path="/admin/super_secret" element={<AdminPage />} />
        <Route path="/admin/super_secret/shows/new" element={<ShowForm />} />
        <Route path="/admin/super_secret/shows/:id/edit" element={<ShowForm />} />
      </Routes>
    </BrowserRouter>
  )
}
